// Module
var code = `<div class="modal-body p-b-0"> <dice-html content="{{ questionTooltipModal.tooltip }}"></dice-html> </div> <div class="modal-footer"> <button type="button" class="btn btn-default pull-left" ng-click="questionTooltipModal.close()" translate="Generic.Close"> Close </button> </div> `;
// Exports
module.exports = code;